import * as React from "react";
import "./ReportsTable.css";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import ReportsTableActionMenu from "./ReportsTableActionMenu";
import { Report } from "../types/Report";
import ReportViewDialog from "./ReportView/ReportViewDialog";
import ReportDeleteDialog from "./ReportView/ReportDeleteDialog";
import ReportStatusIndicator from "../components/ReportStatusIndicator";

interface Props {
  reports: Report[] | undefined;
  setReports: React.Dispatch<React.SetStateAction<Report[] | undefined>>;
}

export default function ReportsTable({ reports, setReports }: Props) {
  const [reportViewOpen, setreportViewOpen] = React.useState(false);
  const [reportDeleteOpen, setReportDeleteOpen] = React.useState(false);
  const [reportSelected, setReportSelected] = React.useState<Report>();

  if (!reports) {
    return <p>Cargando...</p>;
  }

  const columns: GridColDef<(typeof reports)[number]>[] = [
    {
      field: "createdAt",
      type: "dateTime",
      headerName: "Fecha y hora",
      minWidth: 200,
      flex: 1,
      valueGetter: (value) => new Date(value),
    },
    {
      field: "status",
      headerName: "Estado",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => <ReportStatusIndicator report={params.row} />,
    },
    {
      field: "reportPeriod",
      headerName: "Periodo",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "type",
      headerName: "Tipo",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "notes",
      headerName: "Notas",
      minWidth: 300,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => (
        <ReportsTableActionMenu
          handleOpenView={() => {
            setReportSelected(params.row);
            setreportViewOpen(true);
          }}
          handleOpenDeleteDialog={() => {
            setReportSelected(params.row);
            setReportDeleteOpen(true);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <DataGrid
          rows={reports}
          getRowId={(row) => row._id}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
            sorting: {
              sortModel: [{ field: "createdAt", sort: "desc" }],
            },
          }}
          pageSizeOptions={[10]}
          disableRowSelectionOnClick
          getRowHeight={() => "auto"}
          autoHeight
        />
      </Box>
      {reportSelected && (
        <ReportViewDialog
          open={reportViewOpen}
          report={reportSelected}
          setOpen={setreportViewOpen}
          canCreateNewReport={
            !reports.some(
              (report) =>
                report.status === "En progreso" &&
                report._id !== reportSelected._id,
            )
          }
        />
      )}
      {reportSelected && (
        <ReportDeleteDialog
          open={reportDeleteOpen}
          report={reportSelected}
          setOpen={setReportDeleteOpen}
          setReports={setReports}
        />
      )}
    </>
  );
}
